export class VerifyCheckRequest {
  public checkNumber: string
  public payer: string
  public checkDate: Date
  public checkAmount: number
  public refund: boolean
}
